import React, { useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import InputField from '../../../utils/InputField';
import { ApiAdminInfoUpdate } from '../AdminsPageOperation';

function EditAdminModal({ closeEditModal, setReloadKey, setInfoReloadKey, data }) {
    const { id, firstName, lastName, primaryEmail, primaryPhone, status } = data;
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Id: id,
        FirstName: firstName || '',
        LastName: lastName || '',
        Email: primaryEmail || '',
        Phone: primaryPhone || '',
        Status: status || ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((d) => ({ ...d, [name]: value }));
    };
    const { setMessage } = useTemplate();
    const handleUpdateCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        ApiAdminInfoUpdate(id, formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeEditModal();
                setReloadKey((d) => d + 1);
                setInfoReloadKey((d) => d + 1);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleUpdateCustomer} className="flex flex-col gap-2 md:gap-4">
            <div className="flex justify-between items-center gap-2 md:gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Doe"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="flex justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="Email"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Phone Number"
                    name="Phone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeEditModal()} />
                <ButtonPrimary title="Update" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default EditAdminModal;
